import { hash } from '@ember/helper';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import { type IntlService } from 'ember-intl';

import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';

const bem = getBem(styles);

interface LoaderSignature {
  Args: {
    isWaiting?: boolean;
    isInline?: boolean;
    message?: string;
  };
}

export default class UiLoaderComponent extends Component<LoaderSignature> {
  // Service
  @service declare intl: IntlService;

  // Getter and setter
  get message() {
    return this.args.message ?? this.intl.t('ui.loader.message');
  }

  // Template
  <template>
    {{#if @isWaiting}}
      <div class={{bem (hash is-loading=@isWaiting is-inline=@isInline)}}>
        <span class={{bem 'spinner'}}></span>
        <div class={{bem 'message'}}>{{this.message}}</div>
      </div>
    {{/if}}
  </template>
}
